import { api_configuration } from "../../common";
import api_cs = api_configuration.types.client_state.alan_api;
import DestructorTree from "../DestructorTree";
import { registrationInitialized } from "../state/registerClientState";
import { Failed } from "../Status";
import { ScalarProvider, WeakCache, createVariable } from "../../../../../stream";
import { toStream, toVariable } from "../toStream";

/**@deprecated*/
export function getValue(number_property: api_cs.Cnumber__type__property): number | undefined {
	switch (number_property.properties.is_set.state.name) {
		case "no":
			return undefined;
		case "yes":
			return number_property.properties.is_set.state.node.properties.number.value;
	}
}

/**@deprecated*/
export async function subscribeToValue<R>(
	number_property: api_cs.Cnumber__type__property,
	destructor: DestructorTree,
	callback: (value: number | undefined, destructor: DestructorTree) => R
): Promise<R> {
	await registrationInitialized(number_property);
	let value: number | undefined | null = null;
	let child_destructor = destructor.addChild();
	const on_value = (new_value: number | undefined) => {
		if (value !== null && value !== new_value) {
			child_destructor.destroy();
			child_destructor = destructor.addChild();
			callback(new_value, child_destructor);
		}
		value = new_value;
	};
	destructor.subscribeToStategroup(number_property.properties.is_set, (destructor) => {
		switch (number_property.properties.is_set.state.name) {
			case "yes": {
				const $ = number_property.properties.is_set.state.node;
				return destructor.subscribeToNumber($, "subscribe_number", on_value);
			}
			case "no":
				return on_value(undefined);
			default:
				return unexpectedState(number_property.properties.is_set.state);
		}
	});
	return callback(getValue(number_property), child_destructor);
}

export const value = WeakCache<api_cs.Cnumber__type__property, ScalarProvider<number | Failed>>((property) =>
	createVariable(
		toStream(property.properties.is_set)
			.stateSwitch({
				no: () => Failed as number | Failed,
				yes: ($) => toVariable($, "number"),
			})
			.pipe((v) => v)(),
		false
	)
);
